export default {"src":"/_next/static/media/user.fa6cc25a.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};